module.exports = __webpack_public_path__ + "img/feature_jy_bg.6cdf63e0.png";